export default "__VITE_ASSET__B5oj8l8n__"